import script from "./DialogIndustrial.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogIndustrial.vue?vue&type=script&setup=true&lang=ts"

import "./DialogIndustrial.vue?vue&type=style&index=0&id=e18d91d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e18d91d6"]])

export default __exports__